import { ForbiddenError } from '@bmwe/data';
import type { PermissionSet } from './roleAssigments';
import { CHOICES_PERMISSIONS, getPermissionSet } from './roleAssigments';
import type { RouterContext } from '../types';

export function createPermissionGuard(permission: PermissionSet) {
  return ({
    context,
  }: {
    context: RouterContext;
    location: { href: string };
  }) => {
    if (context.auth.hasPermission(permission)) {
      return;
    }
    throw new ForbiddenError();
  };
}

export function createObjectPermissionGuard(
  basePermission: PermissionSet,
  getObjectId: (params: Record<string, string>) => string,
) {
  return ({
    context,
    params,
  }: {
    context: RouterContext;
    location: { href: string };
    params: Record<string, string>;
  }) => {
    const objectId = getObjectId(params);
    const permission: PermissionSet = {
      ...basePermission,
      dossierId: objectId,
    };

    if (context.auth.hasPermission(permission)) {
      return;
    }
    throw new ForbiddenError();
  };
}

export const choicesReadGuard = createPermissionGuard(
  getPermissionSet(CHOICES_PERMISSIONS, 'READ'),
);
export const choicesEditGuard = createPermissionGuard(
  getPermissionSet(CHOICES_PERMISSIONS, 'EDIT'),
);
